module.exports = __webpack_public_path__ + "img/youtube-solid.540c741a.svg";